import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=9b163ea6&scoped=true&"
import script from "./periodical.vue?vue&type=script&lang=js&"
export * from "./periodical.vue?vue&type=script&lang=js&"
import style0 from "./periodical.vue?vue&type=style&index=0&id=9b163ea6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b163ea6",
  null
  
)

export default component.exports